import { useEffect, useState } from "react";
import { Info, X } from "lucide-react";

const STORAGE_KEY = "pricing_notice_dismissed_v1";

export default function PricingNotice() {
  const [open, setOpen] = useState(false);
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      const t = setTimeout(() => setOpen(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    if (dontShow) localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="pricing-notice-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 md:p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 mb-4">
          <div className="w-11 h-11 shrink-0 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#0F2741] grid place-items-center text-white">
            <Info className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <h2 className="font-display text-2xl text-[#0F2741]">Prezzi alimenti: nota informativa</h2>
            <p className="text-xs text-[#2563EB] uppercase tracking-wider font-semibold mt-1">Importante</p>
          </div>
          <button onClick={close} data-testid="pricing-notice-close-x" className="text-slate-400 hover:text-slate-700">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="space-y-3 text-sm text-slate-600 leading-relaxed">
          <p>
            I <strong>prezzi degli ingredienti</strong> precaricati nel database sono <strong>stimati sulla media nazionale</strong> italiana
            e potrebbero non riflettere il tuo prezzo d'acquisto reale.
          </p>
          <p>
            ✅ Tutti i prezzi sono <strong>editabili manualmente</strong> dalla pagina Ingredienti / Piatti.
          </p>
          <p>
            🔁 Caricando una <strong>fattura/DDT</strong> dalla pagina <strong>OCR Fatture</strong> il sistema aggiorna automaticamente i prezzi
            d'acquisto degli ingredienti riconosciuti e registra il fornitore se non esiste.
          </p>
          <p className="text-xs text-slate-500">
            Il preventivo viene calcolato dal <strong>costo reale</strong> per il ristoratore + percentuale di ricarico configurabile nelle Impostazioni.
          </p>
        </div>
        <label className="flex items-center gap-2 mt-6 text-sm text-slate-600 cursor-pointer">
          <input type="checkbox" checked={dontShow} onChange={(e) => setDontShow(e.target.checked)} data-testid="pricing-notice-dont-show" className="accent-[#2563EB] w-4 h-4" />
          <span>Non mostrare più questo messaggio</span>
        </label>
        <div className="mt-5 flex justify-end">
          <button onClick={close} data-testid="pricing-notice-ok" className="btn-primary">Ho capito</button>
        </div>
      </div>
    </div>
  );
}
